import { Heading } from "@chakra-ui/react";

export default function TabHeading({content,size}){

    return <Heading color="white" size={size} mt="8px" mb="8px">{content}</Heading>
}